import React, { useState } from "react";
import { Grid, TextField, MenuItem, InputAdornment, IconButton } from "@mui/material";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const UserFormFields = ({ userData, handleChange, editUser }) => {
  console.log("editUser", editUser);
  const [showPassword, setShowPassword] = useState(false);
  const isPasswordValid = (password) => {
    const regex = /^(?=.*[A-Z])(?=.*[^A-Za-z0-9]).{8,}$/;
    return regex.test(password);
  };

  return (
    <>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Username"
          name="username"
          value={userData.username}
          onChange={handleChange}
          required
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Email"
          name="email"
          type="email"
          value={userData.email}
          onChange={handleChange}
          required
        />
      </Grid>
      
      <Grid item xs={12}>
        <TextField
          fullWidth
          label={editUser ? "Change Password" : "Password"}
          name="password"
          type={showPassword ? "text" : "password"}
          value={userData.password}
          onChange={handleChange}
          required={!editUser}
          error={
            userData.password !== "" && !isPasswordValid(userData.password)
          }
          helperText={
            userData.password !== "" && !isPasswordValid(userData.password)
              ? "Password must be at least 8 characters long, contain 1 uppercase letter and 1 special character."
              : ""
          }
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setShowPassword((prev) => !prev)}
                  edge="end"
                  tabIndex={0}
                  aria-label={showPassword ? 'Hide password' : 'Show password'}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Contact Number"
          name="contactNumber"
          value={userData.contactNumber}
          onChange={handleChange}
          required
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          select
          fullWidth
          label="Status"
          name="status"
          value={userData.status}
          onChange={handleChange}
          required
        >
          <MenuItem value="ACTIVE">ACTIVE</MenuItem>
          <MenuItem value="INACTIVE">INACTIVE</MenuItem>
        </TextField>
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          select
          fullWidth
          label="Role"
          name="role"
          value={userData.role}
          onChange={handleChange}
          required
        >
          {/* <MenuItem value="ADMIN">ADMIN</MenuItem> */}
          <MenuItem value="COACH">COACH</MenuItem>
        </TextField>
      </Grid>
    </>
  );
};

export default UserFormFields;
